// @ts-strict-ignore
import React from 'react';

import { Pressable } from 'react-native-web';
import { Box } from '@styleseat/ui';
import { BasicMenuIcon } from '../../ui/Icons';

import './SidebarToggle.module.scss';

export type SidebarToggleProps = {
  toggle: () => void;
  shouldDisplayOnDesktopSize: boolean;
  size: number;

};

/**
 * Displays a hamburger icon which, when pressed, toggles the sidebar open and closed.
 */
export const SidebarToggle = ({
  toggle,
  shouldDisplayOnDesktopSize,
  size = 24,
}) => (
  <Pressable
    onPress={toggle}
    testID="sidebar-toggle"
    styleName={shouldDisplayOnDesktopSize ? '' : 'hidden-on-desktop'}
  >
    <Box
      width={shouldDisplayOnDesktopSize ? undefined : 40}
      height={shouldDisplayOnDesktopSize ? undefined : 40}
      alignItems="center"
      justifyContent="center"
    >
      <BasicMenuIcon width={size} height={size} />
    </Box>
  </Pressable>
);
